import { UserNotificationResponseDto } from './../models/responses/user-notification.response';
import { Injectable } from '@angular/core';
import { AuthenticationResult } from '../models/authentication-result';
import { BehaviorSubject, Observable } from 'rxjs';
import { AdvanceFilter } from '../../jobs/models/advance-filter';

@Injectable({
  providedIn: 'root'
})
export class UiStateStore {

  _authenticationResult: BehaviorSubject<AuthenticationResult> = new BehaviorSubject(null);
  public readonly authenticatedUser: Observable<AuthenticationResult> = this._authenticationResult.asObservable();

  _errorResult: BehaviorSubject<string> = new BehaviorSubject(null);
  public readonly error: Observable<string> = this._errorResult.asObservable();

  _success: BehaviorSubject<string> = new BehaviorSubject(null);
  public readonly success: Observable<string> = this._success.asObservable();

  _selectedJobId: BehaviorSubject<string> = new BehaviorSubject(null);
  public readonly selectedJobId: Observable<string> = this._selectedJobId.asObservable();

  private _advanceJobFilterSelection: BehaviorSubject<AdvanceFilter> = new BehaviorSubject(null);
  public readonly advanceJobFilterSelection$: Observable<AdvanceFilter> = this._advanceJobFilterSelection.asObservable();

  private _currentNotification: BehaviorSubject<UserNotificationResponseDto> = new BehaviorSubject(null);
  public currentNotification$: Observable<UserNotificationResponseDto>;

  constructor() {
    this.currentNotification$ = this._currentNotification.asObservable();

    const authenticationResult = JSON.parse(localStorage.getItem("authenticationResult"));
    if(authenticationResult){
      this.setAuthenticationResult(authenticationResult);
    }
  }

  public setAuthenticationResult(authenticationResult: AuthenticationResult): void {
    if(!authenticationResult) {
      localStorage.removeItem("authenticationResult");
      this._authenticationResult.next(authenticationResult);
      return;
    }

    localStorage.setItem("authenticationResult", JSON.stringify(authenticationResult));
    this._authenticationResult.next(authenticationResult);
  }

  public setError(error: string): void {
    this._errorResult.next(error);
  }

  public setSuccess(message: string): void {
    this._success.next(message);
  }

  public setSelectedJobId(jobId: string | null): void {
    this._selectedJobId.next(jobId);
  }

  setAdvanceJobFilterSelection = (selection: AdvanceFilter) => {
    this._advanceJobFilterSelection.next(selection);
  }

  public setCurrentNotification = (notification: UserNotificationResponseDto) => {
    this._currentNotification.next(notification);
  }

}
